import { getLocale } from "../runtime";

const da_chooseyourcountrytogetshippingmethods = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vælg dit land for at få forsendelsesmetoder til din lokation.`
};

const en_chooseyourcountrytogetshippingmethods = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Choose your country to get shipping methods for your location.`
};

const es_chooseyourcountrytogetshippingmethods = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Elige tu país para obtener métodos de envío para tu ubicación.`
};

const fi_chooseyourcountrytogetshippingmethods = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Valitse maasi saadaksesi toimitustavat sijaintiisi.`
};

const nb_chooseyourcountrytogetshippingmethods = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Velg ditt land for å få fraktmetoder for din lokasjon.`
};

const sv_chooseyourcountrytogetshippingmethods = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Välj ditt land för att få fraktmetoder för din plats.`
};

const chooseyourcountrytogetshippingmethods = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_chooseyourcountrytogetshippingmethods(inputs)
	if (locale === "en") return en_chooseyourcountrytogetshippingmethods(inputs)
	if (locale === "es") return es_chooseyourcountrytogetshippingmethods(inputs)
	if (locale === "fi") return fi_chooseyourcountrytogetshippingmethods(inputs)
	if (locale === "nb") return nb_chooseyourcountrytogetshippingmethods(inputs)
	if (locale === "sv") return sv_chooseyourcountrytogetshippingmethods(inputs)
	return "chooseYourCountryToGetShippingMethods";
};

export { chooseyourcountrytogetshippingmethods as "chooseYourCountryToGetShippingMethods" };